import React from 'react';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import {
  BREEDER_MESSAGES_PATH,
  BUYER_MESSAGES_PATH
} from 'dpl/shared/constants/urls';
import { get } from 'dpl/shared/utils/object';

interface ContactQuizSuccessBannerProps {
  breederProfileId: number | string;
  submittedAtLabel?: string | null;
  className?: string;
  containerClassName?: string;
}

export default function ContactQuizSuccessBanner({
  breederProfileId,
  className,
  containerClassName = 'container-xxl',
  submittedAtLabel
}: ContactQuizSuccessBannerProps) {
  const currentUser = useCurrentUser();

  const initialInquiries = get(
    currentUser,
    'value.data.breeder_profiles_initial_inquiries',
    []
  );

  const initialInquiry = initialInquiries.find(
    (inquiry: any) =>
      Number(inquiry.breeder_profile_id) === Number(breederProfileId)
  );
  const conversationId = initialInquiry?.conversation_id;
  const messagesPath = currentUser.isBreeder
    ? BREEDER_MESSAGES_PATH
    : BUYER_MESSAGES_PATH;
  const messengerHref = conversationId
    ? `${messagesPath}/active/${conversationId}`
    : null;

  return (
    <div
      className={classnames(
        'ContactQuizSuccessBanner bg-teal-light pv5 w-100',
        className
      )}
    >
      <div className={containerClassName}>
        <div className="flex items-center gap-12">
          <div className="bg-stroll-mid br-100 padding-h-10 padding-v-10 padding-h-6-ns padding-v-6-ns">
            <Icon
              name="fetch-success"
              width="20px"
              height="20px"
              className="green-dark-700"
            />
          </div>

          <div className="flex flex-column flex-md-row justify-between-ns w-100">
            <div className="font-16">
              {submittedAtLabel
                ? `Your request was sent ${submittedAtLabel}`
                : 'Your request was sent'}
            </div>
            {messengerHref && (
              <a
                className="forest-dark-900 font-16 fw-medium"
                href={messengerHref}
              >
                Go to messenger
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
